import React from 'react';
import { G, Path, Rect } from 'react-native-svg';
import { DT } from '../tokens';

type Props = { x: number; y: number; width: number; height: number; loops?: number };

/** Heating/cooling coil inside a duct section. */
export function CoilSymbol({ x, y, width, height, loops = 4 }: Props) {
  // Build a sinusoidal wave path inside the duct
  const step = width / (loops * 2);
  let d = `M${x + 4},${y + height / 2}`;
  for (let i = 0; i < loops * 2; i++) {
    const cx1 = x + 4 + i * step + step * 0.3;
    const cy1 = i % 2 === 0 ? y + 8 : y + height - 8;
    const cx2 = x + 4 + i * step + step * 0.7;
    const cy2 = cy1;
    const ex = x + 4 + (i + 1) * step;
    const ey = y + height / 2;
    d += ` C${cx1},${cy1} ${cx2},${cy2} ${ex},${ey}`;
  }
  return (
    <G>
      <Rect x={x} y={y} width={width} height={height} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.5" />
      <Path d={d} fill="none" stroke={DT.varColor} strokeWidth="2" opacity={0.8} />
    </G>
  );
}
